module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2-1"
  }, [_c('b', [_vm._v("Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_03_fm#a1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Holland Jenkins, "), _c('i', [_vm._v("Frontispiece")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292749375_12_htit1#a2"
    }
  }, [_vm._v("Republic of Texas (map)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292749375_13_ch1#a3"
    }
  }, [_vm._v("Austin’s Little Colony (map)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292749375_13_ch1#a4"
    }
  }, [_vm._v("Bastrop, Texas (map)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indians")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Storming of the Alamo")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indian horsemen")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Santa Anna")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Felix Huston")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward Burleson")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ben McCulloch")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sam Highsmith in Santa Anna’s uniform")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R. M. Williamson")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jack Hays")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John B. Jones")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caddo chief")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Placido, Chief of the Tonkawas")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kiowa chief")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Battle of Plum Creek")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indian war dance")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comanche warrior")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trading with the Indians")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Austin in 1844")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Texas Rangers, Company D, in 1887")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home of A. Wiley Hill in Bastrop")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The French Embassy in Austin")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home of Campbell Taylor in Bastrop")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home of Col. Washington Jones in Bastrop")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home of John Holland Jenkins in Bastrop")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749375_20_ch8#a30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Twohig residence in San Antonio")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e002c04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292749375_11_illu.vue
// module id = 87
// module chunks = 0